import { render } from "./DocumentacionMotoComponent.vue?vue&type=template&id=172f4f76&scoped=true"
import script from "./DocumentacionMotoComponent.vue?vue&type=script&lang=js"
export * from "./DocumentacionMotoComponent.vue?vue&type=script&lang=js"

import "./DocumentacionMotoComponent.vue?vue&type=style&index=0&id=172f4f76&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-172f4f76"]])

export default __exports__